import { render, staticRenderFns } from "./AddPracticeView.vue?vue&type=template&id=372711e6&scoped=true&"
import script from "./AddPracticeView.vue?vue&type=script&lang=ts&"
export * from "./AddPracticeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372711e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
